import { z } from 'zod';

export const FMIUserFormSchema = z
  .object({
    id: z.string(),
    concurrencyToken: z.string().optional(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string().email('Please enter valid email'),
    jobTitle: z.string(),
    roles: z.array(
      z.object({
        id: z.string(),
        name: z.string(),
      }),
    ),
  })
  .superRefine((data, ctx: any) => {
    if (!data.firstName || !data.firstName.trim()) {
      ctx.addIssue({
        path: ['firstName'],
        message: 'First name is required',
        code: 'custom',
      });
    }

    if (!data.lastName || !data.lastName.trim()) {
      ctx.addIssue({
        path: ['lastName'],
        message: 'Last name is required',
        code: 'custom',
      });
    }

    if (!data.email || !data.email.trim()) {
      ctx.addIssue({
        path: ['email'],
        message: 'Email is required',
        code: 'custom',
      });
    }

    if (data.roles.length === 0) {
      ctx.addIssue({
        path: ['roles'],
        message: 'Role is required',
        code: 'custom',
      });
    }
  });
